import borders from "@/themes/base/borders";
import boxShadows from "@/themes/base/boxShadows";
import colors from "@/themes/base/colors";

const { white } = colors;
const { md } = boxShadows;
const { borderRadius } = borders;

const tableContainer = {
  styleOverrides: {
    root: {
      backgroundColor: white.main,
      boxShadow: md,
      borderRadius: borderRadius.xl,
    },
  },
};

export default tableContainer;
